<template>
    <div class="moderation page-container">
       <PageContent :content="this.content"></PageContent>
    </div>
</template>
<script>
    import training from '../content/training.json'
    import PageContent from "../components/PageContent";


    export default {
        components: {PageContent},
        metaInfo() {
            return {
                title: this.page.title,
                titleTemplate: "%s | DrThumm GmbH",
                meta: [
                    { name: 'description', content: 'Dr Thumm GmbH' }
                ]
            }
        },
        data() {
            return {
                content: {
                    training
                }
            }
        },
        updated() {
            this.showImage = true
        },
        beforeCreate() {
            document.body.className = ""
        }
    }
</script>
<style lang="sass">

</style>